import { CalendarOutput } from '@cityair/namespace';

export function getIntervalText(time: CalendarOutput, formatter: (time: number) => string): string {
    const textStart = formatter(time?.begin);
    const textEnd = formatter(time?.end);

    return `${textStart} - ${textEnd}`;
}
